import { observer } from 'mobx-react-lite'
import { Box } from 'shared/ui'
import { Tabs, type ITabItem } from 'shared/ui/Tabs'
import { type IRcsPreviewTabs } from 'pages/settings/pages/rcsV2/pages/SenderDetails/store/type'
import { useSenderDetailsContext } from 'pages/settings/pages/rcsV2/pages/SenderDetails/hooks/useSenderDetailsContext'
import { RcsConversationPreview } from './RcsConversationPreview/RcsConversationPreview'
import { RcsProfilePreview } from './RcsProfilePreview/RcsProfilePreview'

export const SenderPreview = observer(() => {
  const { previewTabs, activeTab, setActiveTab } = useSenderDetailsContext()

  const tabs: ITabItem<IRcsPreviewTabs>[] = previewTabs.map((tab) => ({
    key: tab.value,
    name: tab.label,
  }))

  return (
    <Box width={'100%'}>
      <Tabs
        tabs={tabs}
        activeTabKey={activeTab}
        handleSelectTab={(tab) => setActiveTab(tab.key)}
        variant={'default'}
        margin={'24px 0 0'}
        paddingInlineWrap={24}
      />
      <Box padding={'48px 63px'}>
        {activeTab === 'profile' && <RcsProfilePreview />}
        {activeTab === 'conversation' && <RcsConversationPreview />}
      </Box>
    </Box>
  )
})
